module.exports = __webpack_public_path__ + "static/img/4.0821d21.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/sp/4.png
// module id = RhfM
// module chunks = 0